/** support-bot on dev, behind the API Gateway route made for it. */
export const DEV_ASSISTANT_URL =
  "https://de8nw5b65h.execute-api.ap-southeast-1.amazonaws.com/dev/api/support-bot";
/** Where support-bot serves its REST API. */
export const ASSISTANT_API_PATH = "/support-bot/api/v1";
/**
 * The panel's request prefix: the Vite dev server proxies it (config/proxy.config.ts), and deployed builds
 * rewrite it to the support-bot gateway URL (src/utils/api-path-rewriter.ts).
 */
export const ASSISTANT_PROXY_PATH = "/api/assistant";

/** The API Gateway route in front of support-bot: VITE_API_URL_ASSISTANT, else the dev one. */
export function assistantGatewayUrl(apiUrlAssistant: string | undefined): string {
  return (apiUrlAssistant ?? DEV_ASSISTANT_URL).replace(/\/$/, "");
}

/** The panel is for the local dev server and the dev deployment, which is built with --mode test. */
export function isAssistantPanelEnabled(env: string): boolean {
  return env === "development" || env === "test";
}
